import { render, staticRenderFns } from "./SurveyManagement.vue?vue&type=template&id=6a8aad90&scoped=true"
import script from "./SurveyManagement.vue?vue&type=script&lang=js"
export * from "./SurveyManagement.vue?vue&type=script&lang=js"
import style0 from "./SurveyManagement.vue?vue&type=style&index=0&id=6a8aad90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8aad90",
  null
  
)

export default component.exports